import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";
import { getCardFlexConfig, flexPropertyToCss } from "components/Editor/widgets/carousel/card/flexConfig";
import { flexFlowForType } from "components/Editor/widgets/flex/flexFlowRegistry";

function kebabStyleObject(styleObj) {
    return Object.fromEntries(
        Object.entries(styleObj).map(([k, v]) => [k.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`), v])
    );
}

function parseStyle(str) {
    const out = {};
    (str || "").split(";").forEach(decl => {
        const i = decl.indexOf(":");
        if (i === -1) return;
        const k = decl.slice(0, i).trim();
        if (k) out[k] = decl.slice(i + 1).trim();
    });
    return out;
}

function normalizeFlexItems(cardEl) {
    Array.from(cardEl.children).forEach(childEl => {
        const childType = childEl.getAttribute("data-widgetType");
        const { preserveSize, preserveWidth } = flexFlowForType(childType);
        const keepWidth = preserveSize || preserveWidth;
        const style = parseStyle(childEl.getAttribute("style"));
        const w = style["width"];
        const h = style["height"];
        ["position", "left", "top", "transform", "margin-left", "marginLeft"].forEach(k => delete style[k]);
        if (!preserveSize) { delete style["height"]; if (!keepWidth) delete style["width"]; }
        style["position"] = "relative";
        style["z-index"] = "1";
        if (w) { style["width"] = w; style["max-width"] = "100%"; style["flex-shrink"] = "0"; }
        if (h && !preserveWidth) { style["height"] = h; }
        childEl.setAttribute("style", cssUtil.toStyleString(style));
    });
}

export async function renderCarouselCardWidget(context, widget, parent, override = null) {
    const breakpoint = context.currentBreakpoint;
    const { flexBoxEnabled, flexProperty } = getCardFlexConfig(widget, breakpoint);

    const parentCarousel = context.widgets.find(w => w.uid === widget.parent);
    const parentFree = parentCarousel?.properties?.desktop?.free === true;
    const cardFlexKeepsFixedBox = flexBoxEnabled && parentFree && breakpoint === "desktop";

    const el = context.document.createElement("div");
    const topDiv = context.document.getElementById("html_renderer");
    el.classList.add("widget", "carousel_card_widget");

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getCarouselCardStyles(widget),
        ...(flexBoxEnabled
            ? {
                  ...kebabStyleObject(flexPropertyToCss(flexProperty)),
                  width: "100%",
                  ...(cardFlexKeepsFixedBox ? {} : { height: "auto" }),
              }
            : {})
    };

    if (override){
        styles["height"] = parent.style.height;
        styles["width"] = breakpoint === "desktop" ? "1200px" : "375px";
        styles["position"] = "relative";
    }

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    if (override){
        topDiv.appendChild(el);
    }
    else{
        parent.appendChild(el);
    }

    renderBackground(context, widget, el);

    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, el, null);
    }

    if (flexBoxEnabled) {
        normalizeFlexItems(el);
    }

    return el;
}

function getCarouselCardStyles(widget) {
    return {
        height: "100%"
    };
}
